<template>
  <div>
    <div id="inner">
      <!--第一页-->
      <div class="main" style="margin: 40px auto; width: 96%">
        <h1 align="center" style="font-size: 32px">广西新皇传媒有限公司发货单</h1>
        <table>
          <tbody>
            <tr>
              <td colspan="4" style="text-align: center">发货日期：2020-12-30</td>
            </tr>
            <tr>
              <td style="text-align: right; width: 120px">送达方：</td>
              <td>XH030107-广西皇之仕乳品科技有限公司</td>
              <td style="text-align: right; width: 120px">订单编号：</td>
              <td style="width: 150px">20201223001</td>
            </tr>
          </tbody>
        </table>
        <div class="list">
          <table style="border: 1px solid black">
            <thead>
              <tr>
                <th style="width: 150px">商品编码</th>
                <th style="width: 300px">商品名称</th>
                <th style="width: 150px">商品规格</th>
                <th style="width: 80px">单位</th>
                <th style="width: 80px">单价</th>
                <th style="width: 80px">数量</th>
                <th style="width: 100px">金额</th>
                <th>活动</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>商品编码</td>
                <td>商品名称</td>
                <td>商品规格</td>
                <td>单位</td>
                <td>单价</td>
                <td>数量</td>
                <td>金额</td>
                <td>活动</td>
              </tr>
              <tr>
                <td>商品编码</td>
                <td>商品名称</td>
                <td>商品规格</td>
                <td>单位</td>
                <td>单价</td>
                <td>数量</td>
                <td>金额</td>
                <td>活动</td>
              </tr>
            </tbody>
          </table>
        </div>

        <table>
          <tbody>
            <tr>
              <td colspan="4">公司地址：广西南宁市西乡塘区丰达路65号</td>
            </tr>
            <tr>
              <td colspan="4">送货地址：</td>
            </tr>
            <tr>
              <td width="25%">审批人：</td>
              <td width="25%">经手人：</td>
              <td width="25%">送货人：</td>
              <td width="25%">签收人：</td>
            </tr>
            <tr>
              <td colspan="4">备注</td>
            </tr>
            <tr>
              <td colspan="4">页码：第1页/共4页</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--startprint-->
      <!-- <body style="background-color: #fff; width: 100%; height: 100%">
        <div>startprint</div>
        <div class="main" style="margin: 40px auto; width: 96%; font-family: Simsun; line-height: 2em; font-size: 14px">
          <h1 align="center" style="font-size: 32px">广西新皇传媒有限公司发货单</h1>
          <table style="margin: 20px auto; width: 100%; border-collapse: collapse; line-height: 2em">
            <tr>
              <td colspan="4" style="text-align: center; font-size: 22px">发货日期：2020-12-30</td>
            </tr>
            <tr>
              <td style="text-align: right; width: 120px; font-size: 22px">送达方：</td>
              <td style="width: 150px; font-size: 22px">XH030107-广西皇之仕乳品科技有限公司</td>
              <td style="text-align: right; width: 120px; font-size: 22px">订单编号：</td>
              <td style="width: 150px; font-size: 22px">20201223001</td>
            </tr>
          </table>
          <div class="list">
            <table style="border: 1px solid black; margin: 20px auto; width: 100%; border-collapse: collapse; line-height: 2em">
              <thead>
                <tr>
                  <th style="width: 180px; border: 1px solid #999; color: black; padding: 4px 8px; text-align: center; font-weight: bold">商品编码</th>
                  <th style="width: 300px; border: 1px solid #999; color: black; padding: 4px 8px; text-align: center; font-weight: bold">商品名称</th>
                  <th style="width: 150px; border: 1px solid #999; color: black; padding: 4px 8px; text-align: center; font-weight: bold">商品规格</th>
                  <th style="width: 80px; border: 1px solid #999; color: black; padding: 4px 8px; text-align: center; font-weight: bold">单位</th>
                  <th style="width: 80px; border: 1px solid #999; color: black; padding: 4px 8px; text-align: center; font-weight: bold">单价</th>
                  <th style="width: 80px; border: 1px solid #999; color: black; padding: 4px 8px; text-align: center; font-weight: bold">数量</th>
                  <th style="width: 100px; border: 1px solid #999; color: black; padding: 4px 8px; text-align: center; font-weight: bold">金额</th>
                  <th style="width: 100px; border: 1px solid #999; color: black; padding: 4px 8px; text-align: center; font-weight: bold">活动</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="border: 1px solid #999; text-align: left; padding: 4px 8px; color: #000; font-size: 22px">商品编码</td>
                  <td style="border: 1px solid #999; text-align: left; padding: 4px 8px; color: #000; font-size: 22px">商品名称</td>
                  <td style="border: 1px solid #999; text-align: left; padding: 4px 8px; color: #000; font-size: 22px">商品规格</td>
                  <td style="border: 1px solid #999; text-align: left; padding: 4px 8px; color: #000; font-size: 22px">单位</td>
                  <td style="border: 1px solid #999; text-align: left; padding: 4px 8px; color: #000; font-size: 22px">单价</td>
                  <td>数量</td>
                  <td>金额</td>
                  <td>活动</td>
                </tr>
              </tbody>
            </table>
          </div>

          <table style="margin: 20px auto; width: 100%; border-collapse: collapse; line-height: 2em">
            <tr>
              <td colspan="4" style="font-size: 22px">公司地址：广西南宁市西乡塘区丰达路65号</td>
            </tr>
            <tr>
              <td colspan="4" style="font-size: 22px">送货地址：</td>
            </tr>
            <tr>
              <td width="25%" style="font-size: 22px">审批人：</td>
              <td width="25%" style="font-size: 22px">经手人：</td>
              <td width="25%" style="font-size: 22px">送货人：</td>
              <td width="25%" style="font-size: 22px">签收人：</td>
            </tr>
            <tr>
              <td colspan="4" style="font-size: 22px">备注</td>
            </tr>
            <tr>
              <td colspan="4" style="font-size: 22px">页码：第1页/共1页</td>
            </tr>
          </table>
        </div>
        <div>endprint</div>

        <div @click="getData">
          <span>数据</span>
        </div>

        <div @click="print_page">
          <span>打印订单111</span>
        </div>
      </body> -->
    </div>
    <input type="button" @click="print_page" value="打印" />
  </div>
</template>

<script>

export default {

  data () {

    return {
      orderData: {},
    }
  },

  created () {
    this.getOrderInfo();
  },

  methods: {

    print_page () {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        remove_ie_header_and_footer();
      }
      var bdhtml = window.document.body.innerHTML; //获取当前页的html代码
      // var prnhtml = window.document.getElementById("printpage").innerHTML;

      console.log(bdhtml);

      // var sprnstr = "startprint"; //设置打印开始区域
      // var eprnstr = "endprint"; //设置打印结束区域
      // var prnhtml = bdhtml.substr(bdhtml.indexOf(sprnstr) + 10 + 6); //从开始代码向后取html

      // prnhtml = prnhtml.replaceAll('data-v-0c27403f=""', "");
      // var prnhtml = prnhtml.substring(0, prnhtml.indexOf(eprnstr) - 6); //从结束代码向前取html


      // console.log(prnhtml);
      // window.open();
      // window.document.body.innerHTML = prnhtml;
      window.document.body.innerHTML = bdhtml;
      window.print();
      // 这里延迟关闭是因为在加载的东西比较多的时候，可能dom需要的数据还没加载完就关闭了。这样会导致数据显示不全，所以采用延迟关闭的方法防止数据不全。具体延迟多长时间自己控制。
      setTimeout(cancle1, 9000);
    },

    remove_ie_header_and_footer () {
      var hkey_root, hkey_path, hkey_key;
      hkey_path = "HKEY_CURRENT_USER\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
      try {
        var RegWsh = new ActiveXObject("WScript.Shell");
        RegWsh.RegWrite(hkey_path + "header", "");
        RegWsh.RegWrite(hkey_path + "footer", "");
      } catch (e) { }

      try {
        var RegWsh = new ActiveXObject("WScript.Shell")
        hkey_key = "header"
        RegWsh.RegWrite(hkey_root + hkey_path + hkey_key, "")
        hkey_key = "footer"
        RegWsh.RegWrite(hkey_root + hkey_path + hkey_key, "")
      } catch (e) { }
    },

    cancle1 () {
      window.close();
    },

    getData () {

    },
    broPrint () {
      // window.print();

      // var printHtml = document.getElementById("inner").innerHTML;
      // console.log(printHtml);
      // var newWind = window.open();
      // newWind.document.body.innerHTML = printHtml;
      // newWind.print();
      // newWind.close();
    },

    async getOrderInfo () {
      // console.log(id);
      this.sendOrderId = '202012281552';
      // this.getOrderDetail();
      const { data: res } = await this.$http.get('admin/order/getOrderInfo', {
        params: {
          order_id: this.sendOrderId
        }
      })
      console.log(res)
      if (res.code !== 200) {
        return this.$message.error('获取订单')
      }
      this.orderData = res.result

      setTimeout(() => {
        // window.open()
        // var printHtml = document.getElementById("printPage").innerHTML;
        // console.log(printHtml);
        // document.body.innerHTML = printHtml;
        // window.print();
      }, 500)
    },
  }
}
</script>

<style lang="less" scoped>
.xxxx {
  color: #ffffff;
}

.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: #7fffd4;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}

.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}

body {
  background-color: #fff;
  width: 100%;
  height: 100%;
}

* {
  padding: 0;
  margin: 0;
}

.main {
  font-family: Simsun;
  line-height: 2em;
  font-size: 14px;
}

@media print {
  @page {
    size: A4;
  }
}

table {
  margin: 20px auto;
  width: 100%;
  border-collapse: collapse;
  line-height: 2em;
}

.list th {
  border: 1px solid #999;
  color: black;
  padding: 4px 8px;
  text-align: center;
  font-weight: bold;
}

.list td {
  border: 1px solid #999;
  text-align: left;
  padding: 4px 8px;
  color: #000;
}
</style>
  
